/**
 * Export —— 匯出（`ui-spec.md` P-11）：Excel ／ 憑證包（ZIP）
 * ⚠️ 下載一律**帶 session 驗證**（唔公開任何檔案）。
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TopBar from '../components/TopBar';
import { currentPeriod, exportUrl, type Meta } from '../lib/api';

export default function Export({ meta }: { meta: Meta }) {
  const { t } = useTranslation();
  const [entityId, setEntityId] = useState(meta.entities[0]?.id ?? '');
  const [mode, setMode] = useState<'month' | 'range'>('month');
  const [period, setPeriod] = useState(currentPeriod());
  const [from, setFrom] = useState(`${currentPeriod()}-01`);
  const [to, setTo] = useState(`${currentPeriod()}-28`);
  const params = mode === 'month' ? { entityId, period } : { entityId, from, to };

  return (
    <main className="page">
      <TopBar title={t('export.heading')} />

      <section className="card">
        <div className="fields">
          <label className="field">
            <span>{t('expense.entity')}</span>
            <select value={entityId} onChange={(e) => setEntityId(e.target.value)}>
              {meta.entities.map((e) => <option key={e.id} value={e.id}>{e.name_zh}</option>)}
            </select>
          </label>
          <label className="field">
            <span>{t('export.mode')}</span>
            <select value={mode} onChange={(e) => setMode(e.target.value as 'month' | 'range')}>
              <option value="month">{t('export.mode_month')}</option>
              <option value="range">{t('export.mode_range')}</option>
            </select>
          </label>
          {mode === 'month' ? (
            <label className="field">
              <span>{t('list.month')}</span>
              <input type="month" value={period} onChange={(e) => setPeriod(e.target.value)} />
            </label>
          ) : (
            <>
              <label className="field">
                <span>{t('export.from')}</span>
                <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
              </label>
              <label className="field">
                <span>{t('export.to')}</span>
                <input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
              </label>
            </>
          )}
        </div>

        <div className="row">
          <a className="cta" href={exportUrl('xlsx', params)}>{t('export.xlsx_cta')}</a>
          <a className="cta secondary" href={exportUrl('pack', params)}>{t('export.pack_cta')}</a>
        </div>

        <ul className="kv">
          <li>📊 <b>{t('export.xlsx_what')}</b></li>
          <li>🗂️ <b>{t('export.pack_what')}</b></li>
        </ul>
        <p className="note">{t('export.note')}</p>
      </section>
    </main>
  );
}
